import { Component} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PerformanceService } from '@app/performance/performance.service';
import { TestCaseService } from '@app/testcase/testcase.service';
import { UserService } from '@app/user/user.service';
import { errorMessages } from '@assets/data/constants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { constants } from '@assets/data/constants';
import * as moment from 'moment';

@Component({
  selector: 'app-business-flow-form',
  templateUrl: './business-flow-form.component.html',
  styleUrls: ['./business-flow-form.component.less']
})

export class BusinessFlowFormComponent {

  numberOfBusinessFlow: number = 1;
  userProjects = [];
  loadTestType = 'API';
  testCasesList= [];
  selectedTestCase: any;
  loadTestConfig = [];
  perfEnvironments = [];
  loadSettingDatas: any;
  selectedLoadTestConfig: any;
  execMultileBusFlow: boolean = false;
  RunbySchedule : boolean = true;
  userForm: any;
  impactedSystems: any;
  rerun: any;
  perfLabValue: {};
  parallelFlow: any;
  editMode: boolean = false;
  comment: any;

  constructor(private userService: UserService, private toastr: ToastrService, private performanceService: PerformanceService,
    private testCaseService:TestCaseService, public modalService: NgbModal, private formBuilder: FormBuilder, private router: Router,private route: ActivatedRoute) {
     }

  ngOnInit() {
    this.userForm = this.formBuilder.group({
      environment: [null, Validators.required],
      projectName: [null, Validators.required],
      testCaseName: [null, Validators.required],
      loadTestConfigName: [null, Validators.required],
      schedule: [false, Validators.required],
      scheduledTime: [new Date(), Validators.required],
    });
    this.getUserProject();
    this.rerun = this.route.snapshot.params.id;
      if (this.rerun && this.rerun !== undefined) {
        this.loadRerunData(this.rerun);
      }
   }
   loadRerunData(rerunId: any) {
    this.perfLabValue = {};
   this.performanceService.rerunQueue(rerunId).subscribe(data => {
      if (data.code === 200) {
          this.userForm.setValue({
          environment: data.response.environmentMap,
          testCaseName: data.response.testCase,
          loadTestConfigName: data.response.loadTestConfig,
          projectName: data.response.testCase.project,
          schedule: false,
          scheduledTime: new Date()
          })
        this.loadTestType = data.response.loadTestType;
        this.selectedTestCase = data.response.testCase;
        this.comment = data.response.comments ? data.response.comments : null;
        this.selectedLoadTestCofig(data.response.loadTestConfig, true);
        this.fetchTestCase(data.response.testCase.project)
        this.getLoadTestConfig(data.response.testCase)
        this.rerun = null;
      } else {
        this.toastr.error(data.message);
        this.router.navigate(['/performance/loadTesting/queue']);
      }
    });
  }
  updatedLoadTestConfig(data) {
    this.loadTestConfig = this.loadTestConfig.map(item => {
      if (item.id === data.id) {
        return { ...data };
      }
      return item;
    });
  }
  submitForm(){
    if(this.userForm.status !== 'INVALID'){
      var newData= {
        "environmentMap": this.userForm.value.environment,
        "loadTestConfig": this.userForm.value.loadTestConfigName,
        "testCase":this.selectedTestCase,
        "loadTestSettings":null,
        "parallelFlow": this.userForm.value.loadTestConfigName.parallelFlow,
        "startTime":this.userForm.value.schedule ? moment(this.userForm.value.scheduledTime).format('YYYY-MM-DD HH:mm:ss') : null,
        "location": this.userForm.value.loadTestConfigName.location,
        "storeResult": this.userForm.value.loadTestConfigName.storeResult,
      }
      newData.testCase.testCaseEndPoints = null;
      newData.loadTestConfig = this.loadTestConfig.find(item => item.id === newData.loadTestConfig.id);
      if (this.userForm.value.loadTestConfigName.impactedSystems !== undefined) {
        this.impactedSystems = this.userForm.value.loadTestConfigName.impactedSystems;
      }
    }
    this.errorHandling();
    if(this.errorHandling()){
  this.updateLoadSetting(newData.testCase.id, newData.loadTestConfig).then(result => {
    this.performanceService.saveLoadTesting(newData).subscribe(data => {
    if (data.code === 200) {
      this.toastr.success(data.message);
        this.router.navigate(['/performance/loadTesting/queue']);
          } else {
            this.toastr.error(data.message);
          }
      });
    }).catch(errMsg => this.toastr.error(errMsg));
  }
  }


  formatDateTimeToString(dateTime: any, timeStamp: any) {
    const month = dateTime.month > 9 ? dateTime.month : '0' + dateTime.month;
    const selectedTime = timeStamp.hour + ':' + timeStamp.minute + ':' + timeStamp.second;
    return (dateTime.year + '-' + month + '-' + dateTime.day + ' ').concat(selectedTime);
  }
  updateLoadSetting(testCaseId, loadTestConfig) {
    return new Promise((resolve, reject) => {
      this.testCaseService.updateLoadConfiguration(testCaseId, loadTestConfig).subscribe(data => {
        if (data.code === 200) {
          resolve(constants.configUpdatedSuccessfullyInfo);
        } else {
          reject(data.message);
        }
      });

    });
  }
  errorHandling = () => {
    const requiredFields = [];
    Object.keys(this.userForm.controls).forEach((control) => {
      if (this.userForm.controls[control].hasError('required')) {
        requiredFields.push(control);
      }
    });
    if (requiredFields.length === 0){
      return true
    }else{
   this.toastr.error(`Please fill the ${requiredFields} required fields`);
   }
  }

  changeLoadTestType(event){
    if(event){
      this.loadTestType = 'API';
    }else{
      this.loadTestType = 'WEB';
    }
    this.userForm.reset()
    this.fetchTestCase(this.userForm.value.projectName)
    this.selectedLoadTestConfig = false
    this.userForm.patchValue({
      ["schedule"]: false,
      ['scheduledTime']: new Date(),
    })
  }

  clearForm(source){
    if(source === 'project'){
      this.testCasesList = []
      this.loadTestConfig = []
      this.userForm.patchValue({
        ["environmentMap"]: null,
        ["loadTestConfigName"]:null,
        ["testCaseName"]: null,
        ['environment']: null,

      })
    }else{
      this.loadTestConfig = []
      this.userForm.patchValue({
        ["environmentMap"]: null,
        ["loadTestConfigName"]:null,
      })
    }
    this.selectedLoadTestConfig = false;
  }

  getCurrentTime(){
    const todayDate = moment();
    let date = todayDate.tz('America/Los_Angeles').format('DD-MM-YYYY hh:mm A');
    return date;

  }

   addBusinessFlow =()=>{
    this.numberOfBusinessFlow++;
  }

  removeBusinessFlow =()=>{
    this.numberOfBusinessFlow--;
  }

  multBusFlowExec =()=>{
    this.execMultileBusFlow = !this.execMultileBusFlow;
  }

  getUserProject() {
    this.userService.getMyProjectList().subscribe(data => {
      if (data.code === 200) {
        this.userProjects = data.response;
      } else {
        this.toastr.error(errorMessages.userProjectsError + data.message);
      }
    });
  }

  changeScheduleMethod(){
    this.RunbySchedule = !this.RunbySchedule;
  }
  fetchTestCase = (event) => {
    if(!this.rerun){
      this.clearForm('project')
}
   if(event){
    this.performanceService.getLoadTestingNFTC(event.id, this.loadTestType).subscribe(data => {
      if (data.code === 200) {
        this.testCasesList = data.response;
      } else {
        this.toastr.error('Fetch NF Test-Case Error: ' + data.message);
      }
    });}
  }


  getLoadTestConfig(testCase) {
    if(testCase){
    this.selectedTestCase = testCase;
    this.selectedTestCase.project.id = this.userForm.value.projectName.id;
    this.getEnv();
    if(!this.rerun){
      this.clearForm('testCase')
    }
    this.testCaseService.getLoadConfiguration(testCase.id).subscribe(data => {
        if (data.code === 200) {
          this.loadTestConfig = data.response;

          }
     });
    }
  }

  selectedLoadTestCofig(event, rerun: boolean) {
    this.comment = rerun ? this.comment : null;
    // this.loadTestConfig[0] = event
    this.selectedLoadTestConfig=event;
  }

  getEnv() {
    this.testCaseService.getEnv(this.userForm.value.projectName.id).subscribe(data => {
      if (data.code === 200) {
        this.perfEnvironments = data.response;
      }
    });
  }

}


